<template>
  <knowledge-view
    class="bg-gray-1"
    :custom-width="width"
    :config="getConfig()"
    @go-to-entity="goToEntity"
    @empty-view="fixEmptyView"
    @change-language="changeLanguage"
  >
  </knowledge-view>
</template>

<script setup lang="ts">
import useEntities from '@commons/composables/useEntities'

const configStore = useConfigStore()
const { width } = storeToRefs(configStore)

const { goToEntity, changeLanguage, getConfig } = useEntities()
const { fixEmptyView } = useApp()
</script>
